/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminPlayerDetail,
  AdminPlayerStats,
  ApiErrorResponse,
  MatchCreator,
  PlanResponse,
  PlanUpdateRequest,
} from '../models/index';
import {
    AdminPlayerDetailFromJSON,
    AdminPlayerDetailToJSON,
    AdminPlayerStatsFromJSON,
    AdminPlayerStatsToJSON,
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    MatchCreatorFromJSON,
    MatchCreatorToJSON,
    PlanResponseFromJSON,
    PlanResponseToJSON,
    PlanUpdateRequestFromJSON,
    PlanUpdateRequestToJSON,
} from '../models/index';

export interface GetAdminPlayerDetailRequest {
    playerId: string;
}

export interface UpdateAdminPlanRequest {
    code: string;
    planUpdateRequest: PlanUpdateRequest;
}

/**
 * AdminApi - interface
 * 
 * @export
 * @interface AdminApiInterface
 */
export interface AdminApiInterface {
    /**
     * Generated tournament matches without a persisted creator are omitted.
     * @summary List recorded match creators (administrators only)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getAdminMatchCreatorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MatchCreator>>>;

    /**
     * Generated tournament matches without a persisted creator are omitted.
     * List recorded match creators (administrators only)
     */
    getAdminMatchCreators(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MatchCreator>>;

    /**
     * 
     * @summary Get detailed competition and training history for a platform player
     * @param {string} playerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    getAdminPlayerDetailRaw(requestParameters: GetAdminPlayerDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPlayerDetail>>;

    /**
     * Get detailed competition and training history for a platform player
     */
    getAdminPlayerDetail(requestParameters: GetAdminPlayerDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPlayerDetail>;

    /**
     * 
     * @summary List access plans for administrative management
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    listAdminPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanResponse>>>;

    /**
     * List access plans for administrative management
     */
    listAdminPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanResponse>>;

    /**
     * 
     * @summary List platform players with aggregated competition and training statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    listAdminPlayerStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminPlayerStats>>>;

    /**
     * List platform players with aggregated competition and training statistics
     */
    listAdminPlayerStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminPlayerStats>>;

    /**
     * 
     * @summary Update an access plan and its entitlements
     * @param {string} code 
     * @param {PlanUpdateRequest} planUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApiInterface
     */
    updateAdminPlanRaw(requestParameters: UpdateAdminPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanResponse>>;

    /**
     * Update an access plan and its entitlements
     */
    updateAdminPlan(requestParameters: UpdateAdminPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanResponse>;

}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI implements AdminApiInterface {

    /**
     * Generated tournament matches without a persisted creator are omitted.
     * List recorded match creators (administrators only)
     */
    async getAdminMatchCreatorsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MatchCreator>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/matches/admin/creators`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MatchCreatorFromJSON));
    }

    /**
     * Generated tournament matches without a persisted creator are omitted.
     * List recorded match creators (administrators only)
     */
    async getAdminMatchCreators(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MatchCreator>> {
        const response = await this.getAdminMatchCreatorsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get detailed competition and training history for a platform player
     */
    async getAdminPlayerDetailRaw(requestParameters: GetAdminPlayerDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPlayerDetail>> {
        if (requestParameters['playerId'] == null) {
            throw new runtime.RequiredError(
                'playerId',
                'Required parameter "playerId" was null or undefined when calling getAdminPlayerDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/player-stats/{playerId}`;
        urlPath = urlPath.replace(`{${"playerId"}}`, encodeURIComponent(String(requestParameters['playerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPlayerDetailFromJSON(jsonValue));
    }

    /**
     * Get detailed competition and training history for a platform player
     */
    async getAdminPlayerDetail(requestParameters: GetAdminPlayerDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPlayerDetail> {
        const response = await this.getAdminPlayerDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List access plans for administrative management
     */
    async listAdminPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/plans`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlanResponseFromJSON));
    }

    /**
     * List access plans for administrative management
     */
    async listAdminPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanResponse>> {
        const response = await this.listAdminPlansRaw(initOverrides);
        return await response.value();
    }

    /**
     * List platform players with aggregated competition and training statistics
     */
    async listAdminPlayerStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminPlayerStats>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/admin/player-stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminPlayerStatsFromJSON));
    }

    /**
     * List platform players with aggregated competition and training statistics
     */
    async listAdminPlayerStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminPlayerStats>> {
        const response = await this.listAdminPlayerStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update an access plan and its entitlements
     */
    async updateAdminPlanRaw(requestParameters: UpdateAdminPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanResponse>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling updateAdminPlan().'
            );
        }

        if (requestParameters['planUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'planUpdateRequest',
                'Required parameter "planUpdateRequest" was null or undefined when calling updateAdminPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/admin/plans/{code}`;
        urlPath = urlPath.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlanUpdateRequestToJSON(requestParameters['planUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanResponseFromJSON(jsonValue));
    }

    /**
     * Update an access plan and its entitlements
     */
    async updateAdminPlan(requestParameters: UpdateAdminPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanResponse> {
        const response = await this.updateAdminPlanRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
